// extracted by mini-css-extract-plugin
module.exports = {"jobAlerts":"JobAlert_jobAlerts__ohuSX"};